module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/Flowing2.30c41313.png";